// extracted by mini-css-extract-plugin
export default {"tableStyle":"DocumentsTableDetail_tableStyle__Y5vdT"};